<template>
    <div>
        <h2
            v-t="'Mitgliedsausweis'"
            class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
        ></h2>
        <kgr-button
            :value="$t('Mitgliedsausweis herunterladen')"
            @click="clickedDownload"
        />
    </div>
</template>

<script>
import KgrButton from '../common/form/button/KgrButton';
import MemberRepository from '../../js/repository/MemberRepository';

export default {
    name: 'KgrMembershipBadge',
    components: {KgrButton},
    props: {
        hasCounter: {
            type: Boolean,
            required: true,
            default: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            memberHasCounter: false,
        };
    },
    created() {
        this.memberHasCounter = this.hasCounter;
    },
    methods: {
        clickedDownload() {
            if (this.memberHasCounter) {
                this.downloadBadge();
                return;
            }

            MemberRepository
                .createBadgeCounter(this.memberId)
                .then(() => {
                    this.memberHasCounter = true;
                    this.downloadBadge();
                });
        },
        downloadBadge() {
            window.location = MemberRepository.membershipBadgeUrl(this.memberId);
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
